<template>
  <v-alert
    v-if="$store.getters.storeOnline.status === false"
    prominent
    color="primary"
    type="warning"
    transition="scale-transition"
    width="100%"
    class="ma-0"
  >
    <v-row align="start">
      <v-col class="grow">
        <span class="message" v-text="$t($store.getters.storeOnline.message)" />
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: "StoreCloseNotification",
  mounted() {
    document.getElementById("container-discovery").style.paddingBottom =
      "100px";
  },
};
</script>
<style lang="scss" scoped>
.message {
  font-size: 1.4rem;
  font-weight: 800;
}
@media only screen and (min-width: 320px) and (max-width: 479px) {
  .message {
    font-size: 1rem;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .message {
    font-size: 1rem;
  }
}

@media only screen and (min-width: 768px) and (max-width: 999px) and (orientation: landscape) {
  .message {
    font-size: 1rem;
  }
}
</style>
